import { post, del } from '../../xhr/fetch'
import { OPERATION_CENTER_PREFIX } from '../../config'

// 机构列表
export const GET_ORG_LIST = (data) => {
  return post(`${OPERATION_CENTER_PREFIX}/orgGroup/v1/queryOrgGroup`, data)
}

// 新增机构
export const ADD_ORG = (data) => {
  return post(`${OPERATION_CENTER_PREFIX}/orgGroup/v1/saveOrgInfo`, data)
}

// 删除机构
export const DEL_ORG = (data) => {
  return del(`${OPERATION_CENTER_PREFIX}/orgGroup/v1`, data)
}
